import script from "./PlaqueDynamicsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlaqueDynamicsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PlaqueDynamicsPage.vue?vue&type=style&index=0&id=23a18be0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a18be0"]])

export default __exports__